import React from 'react'
import PropTypes from 'prop-types'

import { helpers } from '../../../../helpers'
import { Column, Columns, PrimaryMessage, Picture } from '../../../bulma'
import { Link } from '../../../core'
import { PlatinumRewardsLogo } from '../../../core/icons'

function ItemAddedInfo(props) {
  const { item, product, ...rest } = props
  const formattedProducers = helpers.formatProducers(product.producers)
  const productLink = `p/${product.slug}`

  return (
    <Columns isMobile>
      <Column size="one-third-touch" className="is-one-quarter-desktop">
        <Link linkRef="item-added-image" href={productLink}>
          <Picture
            src={product.display_image_url}
          />
        </Link>
      </Column>
      <Column>
        <h2 className="sans-serif"><Link linkRef="item-added-product" href={productLink}>{item.product.name}</Link></h2>
        <div className="is-size-default serif">
          <em>{formattedProducers}</em>
        </div>
        <p className="listing-price">
          <strong className="list-price">
            {item.variant.display_price}
          </strong>
        </p>
        <div className="secondary-details">
          <div className="is-size-sm"><strong> {item.variant.options_text_analytics} </strong></div>
          <div className="is-size-sm"><strong className="quantity"> Quantity: {item.quantity} </strong></div>
        </div>
        <div className="item-added-platinum">
          <span><PlatinumRewardsLogo className="item-added-platinum-logo" /> <Link linkRef="item-added-platinum" href="/rewards">Earn <strong>{item.variant.platinum_points_earnable_currency}</strong> back in points</Link></span>
        </div>
      </Column>
    </Columns>
  )
}

ItemAddedInfo.defaultProps = {
  item: {},
  product: {},
}

ItemAddedInfo.propTypes = {
  // Item added to cart
  item: PropTypes.object,
  // the product added to the cart
  product: PropTypes.object,
}

export default ItemAddedInfo
